export enum Organization {
  FAO = "FAO",
  ITU = "ITU",
  UN = "UN",
  UNDP = "UNDP",
  UNFPA = "UNFPA",
  UNHCR = "UNHCR",
  UNICC = "UNICC",
  UNICEF = "UNICEF",
  UNIDO = "UNIDO",
  UNJSPF = "UNJSPF",
  UNOPS = "UNOPS",
  UNSSC = "UNSSC",
  WFP = "WFP",
}

export const OrgDomain = {
  [Organization.FAO]: "fao.org",
  [Organization.ITU]: "itu.int",
  [Organization.UN]: "un.org",
  [Organization.UNDP]: "undp.org",
  [Organization.UNFPA]: "unfpa.org",
  [Organization.UNHCR]: "unhcr.org",
  [Organization.UNICC]: "un.org",
  [Organization.UNICEF]: "unicef.org",
  [Organization.UNIDO]: "unido.org",
  [Organization.UNJSPF]: "un.org",
  [Organization.UNOPS]: "unops.org",
  [Organization.UNSSC]: "unssc.org",
  [Organization.WFP]: "wfp.org",
};

/**
 * Returns the organization domain for the given org key, with fallback.
 * @param org Organization key (string)
 */
export function getOrgDomain(org?: string): string {
  const fallback = "un.org";
  if (!org || !(org in OrgDomain)) {
    return fallback;
  }
  return OrgDomain[org as Organization] || fallback;
}
